export const inputClass =
  "w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-100";
export const primaryBtnClass =
  "rounded-lg bg-indigo-600 px-3 py-1.5 text-sm font-semibold text-white hover:bg-indigo-700 disabled:cursor-not-allowed disabled:opacity-60";
export const ghostBtnClass =
  "rounded-lg border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-800 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-60 dark:border-zinc-600 dark:bg-zinc-800 dark:text-zinc-100 dark:hover:bg-zinc-700";
export const dangerBtnClass =
  "rounded-lg border border-red-300 bg-white px-3 py-1.5 text-sm font-medium text-red-700 hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-60 dark:border-red-800 dark:bg-zinc-800 dark:text-red-200 dark:hover:bg-red-950/40";

export const EVENT_STATUS_LABELS: Record<string, string> = {
  unscheduled: "Unscheduled",
  scheduled: "Scheduled",
  in_progress: "In progress",
  complete: "Complete",
  cancelled: "Cancelled",
};

export const EVENT_STATUS_CHIP: Record<string, string> = {
  unscheduled: "bg-gray-500 text-white",
  scheduled: "bg-emerald-600 text-white",
  in_progress: "bg-amber-600 text-white",
  complete: "bg-emerald-700 text-white",
  cancelled: "bg-gray-400 text-white",
};

export const CHECK_IN_LABELS: Record<string, string> = {
  none: "No check-in",
  confirmed: "Confirmed",
  day_before: "Day before",
  en_route: "En route",
  on_site: "On site",
  complete: "Complete",
};

export const CHECK_IN_MILESTONE_ORDER = [
  "confirmed",
  "day_before",
  "en_route",
  "on_site",
  "complete",
] as const;

export const REQUEST_STATUS_LABELS: Record<string, string> = {
  pending: "Pending",
  needs_info: "Needs info",
  approved: "Approved",
  declined: "Declined",
  cancelled: "Cancelled",
};

export const REQUEST_ORIGIN_LABELS: Record<string, string> = {
  sales: "Sales",
  opportunity: "Opportunity",
  opportunity_subscriber: "Subscriber opportunity",
  manufacturing_auto: "Manufacturing auto",
  service_internal: "Internal",
  personal_assistant: "Personal Assistant",
};

export function queueLabel(
  queues: Array<{ id: string; label: string }>,
  queueId: string | null
): string {
  if (!queueId) return "(no queue)";
  return queues.find((q) => q.id === queueId)?.label ?? queueId.slice(0, 8);
}

export function techLabel(techs: Array<{ id: string; display_name: string }>, techId: string | null): string {
  if (!techId) return "(unassigned)";
  return techs.find((t) => t.id === techId)?.display_name ?? techId.slice(0, 8);
}

export function offeringLabel(
  offerings: Array<{ id: string; label: string }>,
  offeringId: string | null
): string {
  if (!offeringId) return "(any offering)";
  return offerings.find((o) => o.id === offeringId)?.label ?? offeringId.slice(0, 8);
}

export function rigLabel(rigs: Array<{ id: string; designation: string }>, rigId: string | null): string {
  if (!rigId) return "(no rig)";
  return rigs.find((r) => r.id === rigId)?.designation ?? rigId.slice(0, 8);
}

export function fmtCents(cents: number | null | undefined): string {
  if (cents == null || !Number.isFinite(cents)) return "—";
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(cents / 100);
}
